import { Link } from "react-router-dom";
import { MessageSquare, ChevronRight } from "lucide-react";

export const ProjectConversations = ({ projectId, sessions }) => (
  <div className="p-6 space-y-2" data-testid="conversations-tab">
    {sessions?.map(s => (
      <Link key={s.id} to={`/projects/${projectId}`} state={{ sessionId: s.id }}
        className="flex items-center gap-3 bg-white border border-border/50 rounded-xl px-4 py-3 hover:border-[#014d7d]/20 transition-colors" data-testid={`session-${s.id}`}>
        <div className="w-8 h-8 rounded-lg bg-[#014d7d]/5 flex items-center justify-center shrink-0"><MessageSquare className="w-4 h-4 text-[#014d7d]" /></div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground truncate">{s.title || s.goal || "Untitled conversation"}</p>
          <p className="text-[10px] text-foreground/50 mt-0.5">{new Date(s.created_at).toLocaleString()}</p>
        </div>
        <ChevronRight className="w-4 h-4 text-foreground/45" />
      </Link>
    ))}
    {sessions.length === 0 && <p className="text-center text-foreground/45 py-8 text-sm">No conversations yet.</p>}
  </div>
);
